import { ChartBuilder } from '@chipinside/chartbuilder'
import { PageBuilderComponentProps } from '@chipinside/pagebuilder/dist/types'
import { JSX } from 'react'

import FormatCell from '#/components/FormatCell'
import TypeThi from '#/components/FormatCell/Types/thi'
import { PageBuilderAction } from '#/store/providers/Pagebuilder/Components/Action'
import { PageBuilderActions } from '#/store/providers/Pagebuilder/Components/Actions'
import { PageBuilderAnchor } from '#/store/providers/Pagebuilder/Components/Anchor'
import { PageBuilderCard } from '#/store/providers/Pagebuilder/Components/Card'
import { PageBuilderCharts } from '#/store/providers/Pagebuilder/Components/Charts'
import { PageBuilderChip } from '#/store/providers/Pagebuilder/Components/Chip'
import { PageBuilderDropdownActions } from '#/store/providers/Pagebuilder/Components/DropdownActions'
import { PageBuilderFilters } from '#/store/providers/Pagebuilder/Components/Filters'
import { PageBuilderIcon } from '#/store/providers/Pagebuilder/Components/Icon'
import { PageBuilderTabs } from '#/store/providers/Pagebuilder/Components/Tabs'

type PageBuilderComponentsProps = Record<string, (props: PageBuilderComponentProps) => JSX.Element>

/* prettier-ignore */
const PageBuilderComponents: PageBuilderComponentsProps = {
  'action':            (props: any) => <PageBuilderAction          {...props} />,
  'actions':           (props: any) => <PageBuilderActions         {...props} />,
  'anchor':            (props: any) => <PageBuilderAnchor          {...props} />,
  'card':              (props: any) => <PageBuilderCard            {...props} />,
  'chart':             (props: any) => <ChartBuilder               {...props} />,
  'chip':              (props: any) => <PageBuilderChip            {...props} />,
  'dashboard-chart':   (props: any) => <PageBuilderCharts          {...props} />,
  "datagrid-status":   (props: any) => {
    /**
     * TODO: se houver mais tipos de FormatCell, substituir datagrid-status por format-cell e mandar todos juntos
     * Padronizar tudo que temos de status, ppi, treatment, etc para usar esse componente
     */
    return <FormatCell type={props?.status_type} value={props?.status_data} />
  },
  'dropdown-actions':  (props: any) => <PageBuilderDropdownActions {...props} />,
  'filters':           (props: any) => <PageBuilderFilters         {...props} />,
  'icon':              (props: any) => <PageBuilderIcon            {...props} />,
  'tab':               (props: any) => <PageBuilderTabs            {...props} />,
  // FormatCells Types
  'thi':               (props: any) => <TypeThi                    {...props} />,
}

export { PageBuilderComponents }
